import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation
} from "react-router-dom";
import MetricListPage from './MetricListPage.js'
import MetricPage from './MetricPage.js'
import { useEffect } from "react";

/**
 * When true, just shows the KG logo instead of the whole site.
 */
const SHOW_PLACEHOLDER_INSTEAD_OF_SITE = false;

/**
 * The class implementing the "just-the-logo" func
 */
const Placeholder = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900 text-white">
      <div>
        <img height={46} src="/whitelogo.png" alt="" style={{ height: 46, width: 'auto' }}/>
      </div>
    </div>
  )
}


/**
 * A utility for scroll
 */
function ScrollToTop () {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}


/**
 * The wrapper for the top-level behaviors: routing, scroll-to-top + kill-switch
 */
function App() {

  if (SHOW_PLACEHOLDER_INSTEAD_OF_SITE) {
    return <Placeholder />
  }
  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route path="/metrics/:id">
          <MetricPage />
        </Route>
        <Route path="/">
          <MetricListPage />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
